//waterdropDetail.js

import React from 'react';
import Particles from 'react-particles';
//import {loadFull} from 'tsparticles';
import { useCallback } from 'react';
import { loadSlim } from "tsparticles-slim";
import './projet.css';

function WaterdropDetail() {
    const imagep1 = require('./image/water.png');

    const particlesInit = useCallback(async engine => {
      console.log(engine);
      // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
      // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
      // starting from v2 you can add only the features you need reducing the bundle size
      //await loadFull(engine);
      await loadSlim(engine);
    }, []);

    const particlesLoaded = useCallback(async container => {
        await console.log(container);
    }, []);

    return (
        <div className='flex'>
          <a href="/" className='back'>Back to Main Page</a>
          <h1>Waterdrop's Journey</h1>
          <p className='center'><i>Develop with Unreal Engine 5.3</i></p>
          <iframe width="560" height="315" title='Introduction Video' src="https://www.youtube.com/embed/9OebQaCpLd8"  allowFullScreen></iframe>
          <div className='download'><a href="https://fl3ur.itch.io/water-drops-journey" className='itchio'>Play the game on Itch.io</a></div>
        <div className="paragraph-container">
          <h3>Game Overview</h3>
          <p>Water Drop’s Journey is a side-scrolling game through a river where the player embodies a small water droplet. The goal is to reach the ocean starting from the mountains. Along this aquatic journey, the player must navigate through various obstacles such as waste and water depletion. The purpose of this adventure is to raise awareness among young people about issues related to water pollution and river warming while describing the stages of the water cycle.</p>
  
          <h3>Gameplay</h3>
          <p>The game is a runner where the main character, our water droplet, must traverse landscapes to reach the ocean. The landscape will scroll, and the droplet will move continuously to follow the horizontal scrolling. Obstacles will appear on the scrolling path to challenge the player's reactions.</p>
  
          <h3>Story</h3>
          <p>In Water Drop's Journey, players embody a water droplet born from a mountain source. Their goal is to guide this water droplet through an epic and educational journey to the sea, its final destination. However, this journey is not without challenges, as the water droplet must navigate through a world filled with obstacles, dangers, and challenges. Players must demonstrate skill and reflexes to avoid the various obstacles that stand in the water droplet's path; each stage of the journey is a unique challenge to overcome. Additionally, human pollution proves to be a formidable enemy, with toxic waste and chemicals contaminating the rivers. Along the way, the water droplet will also encounter dying plants, thirsty and weakened by pollution, which it will try to save as it passes. These rescue actions will help restore life to damaged ecosystems. Water Drop's Journey raises players' awareness of the importance of water preservation and environmental protection.</p>
  
          <h3>Presentation</h3>
          <div className="image-container">
          <div>
              <img src={imagep1} alt="imagep1"/>
              <div className="image-caption"><i>Level illustration</i></div>
            </div>
            </div>

        <div className="columns">
        <div className="column">
            <h4>Developers</h4>
            <ul>
                <li>Antoine Yebouet</li>
                <li>Aubin Saunier</li>
                <li>Julien de Toffoli</li>
                <li>Léo Mougin</li>
                <li>Thibault Boisseau</li>
            </ul>
        </div>

        <div className="column">
            <h4>Artist</h4>
            Léo Mougin
        </div>

        <div className="column">
            <h4>Sound Designer</h4>
            Antoine Yebouet
        </div>

        <div className="column">
            <h4>Supervisor</h4>
            Sorelle Audrey Kamkuimo, Ph. D.
        </div>
        </div>
          </div>
          <div className='particles-container'>
      <Particles 
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
            background: {
                color: {
                    value: "#0d47a1",
                },
            },
            fpsLimit: 120,
            interactivity: {
                events: {
                    onClick: {
                        enable: true,
                        mode: "push",
                    },
                    onHover: {
                        enable: true,
                        mode: "repulse",
                    },
                    resize: true,
                },
                modes: {
                    push: {
                        quantity: 4,
                    },
                    repulse: {
                        distance: 200,
                        duration: 0.4,
                    },
                },
            },
            particles: {
                color: {
                    value: "#ffffff",
                },
                links: {
                    color: "#ffffff",
                    distance: 150,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
                },
                move: {
                    direction: "none",
                    enable: true,
                    outModes: {
                        default: "bounce",
                    },
                    random: false,
                    speed: 6,
                    straight: false,
                },
                number: {
                    density: {
                        enable: true,
                        area: 800,
                    },
                    value: 80,
                },
                opacity: {
                    value: 0.5,
                },
                shape: {
                    type: "circle",
                },
                size: {
                    value: { min: 1, max: 5 },
                },
            },
            detectRetina: true,
        }}
      />
      </div>
      </div>
      );
}

export default WaterdropDetail;
